export enum UserRolesEnum {
  OWNER = 'Owner',
  EMPLOYEE = 'Employee',
  SUPER_ADMIN = 'SA',
}
